// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Inter-Regular400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../fonts/Inter-Medium500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../fonts/Inter-SemiBold600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../fonts/Inter-Bold700.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}
.OrderBy_wrapper__TGIcM {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1em;
  flex-wrap: wrap;
}

.OrderBy_select__zgPX2 .rs-picker-toggle {
  border-radius: 12px !important;
  width: 100% !important;
  height: 44px;
  padding: 14px 17px 14px 42px !important;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  transition: 0.3ms;
  box-sizing: border-box;
  padding-right: 27px !important;
  padding-left: 27px !important;
}
.OrderBy_select__zgPX2 .rs-picker-toggle-clean {
  top: 11px !important;
}
.OrderBy_select_container__5wxI0 {
  position: relative;
}
.OrderBy_select_container__5wxI0 .rs-picker-toggle-wrapper {
  width: 100%;
}
.OrderBy_select_container__5wxI0 .rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-caret {
  top: 12px;
  transition-duration: 0.5s;
  transition-property: transform;
}
.OrderBy_select_container__5wxI0 .rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-clear {
  top: 12px;
}
.OrderBy_select_container__5wxI0 .rs-picker-toggle[aria-expanded="true"] .rs-picker-toggle-caret {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/styles/vendors/fonts.scss","webpack://./src/components/UI/OrderBy/OrderBy.module.scss","webpack://./src/styles/vendors/mixins.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADEA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACAF;ADGA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACDF;ADIA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACFF;AAvBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,eAAA;AAyBF;;AArBE;ECZA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,uCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EDIE,8BAAA;EACA,6BAAA;AAkCJ;AA/BE;EACE,oBAAA;AAiCJ;AA9BE;EACE,kBAAA;AAgCJ;AA/BI;EACE,WAAA;AAiCN;AA9BI;EACE,SAAA;EACA,yBAAA;EACA,8BAAA;AAgCN;AA7BI;EACE,SAAA;AA+BN;AA5BI;EACE,yBAAA;AA8BN","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Regular400.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Medium500.woff2\") format(\"woff2\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-SemiBold600.woff2\") format(\"woff2\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Bold700.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}","@import \"../../../styles/vendors/mixins\";\n@import \"../../../styles/vendors/fonts\";\n\n\n.wrapper{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1em;\n  flex-wrap: wrap;\n}\n\n.select {\n  :global(.rs-picker-toggle){\n    @include input;\n    padding-right: 27px!important;\n    padding-left: 27px!important;\n  }\n\n  :global(.rs-picker-toggle-clean){\n    top: 11px!important;\n  }\n\n  &_container {\n    position: relative;\n    :global(.rs-picker-toggle-wrapper){\n      width: 100%;\n    }\n\n    :global(.rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-caret){\n      top: 12px;\n      transition-duration: 0.5s;\n      transition-property: transform;\n    }\n\n    :global(.rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-clear){\n      top: 12px;\n    }\n\n    :global(.rs-picker-toggle[aria-expanded=\"true\"] .rs-picker-toggle-caret){\n      transform: rotate(180deg);\n    }\n  }\n}\n","@mixin input {\n  border-radius: 12px !important;\n  width: 100% !important;\n  height: 44px;\n  padding: 14px 17px 14px 42px !important;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 14px;\n  transition: 0.3ms;\n  box-sizing: border-box;\n}\n\n@mixin input_default {\n  background-color: #F3F3F4 !important;\n  border: none !important;\n  color: #758282 !important;\n  -webkit-box-shadow: inset 0 0 0 50px #F3F3F4;\n  -webkit-text-fill-color: #758282;\n}\n\n@mixin input_hover {\n  background-color: #F3FFFF !important;\n  border: 1px solid #31C9CA !important;\n  color: #616E6E !important;\n  -webkit-box-shadow: inset 0 0 0 50px #F3FFFF !important;\n  -webkit-text-fill-color: #616E6E;\n}\n\n@mixin input_active {\n  border: 1px solid #ffa368 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff;\n}\n\n@mixin input_error {\n  border: 1px solid #FF5756 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff;\n  margin-bottom: 0 !important;\n}\n\n@mixin input_valid {\n  border: 1px solid #1DB5B6 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `OrderBy_wrapper__TGIcM`,
	"select": `OrderBy_select__zgPX2`,
	"select_container": `OrderBy_select_container__5wxI0`
};
export default ___CSS_LOADER_EXPORT___;
